import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'hr',
  months: [
    'siječanj',
    'veljača',
    'ožujak',
    'travanj',
    'svibanj',
    'lipanj',
    'srpanj',
    'kolovoz',
    'rujan',
    'listopad',
    'studeni',
    'prosinac',
  ],
  monthsShort: ['sij', 'velj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro'],
  weekdays: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
  weekdaysMin: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
  weekdaysShort: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'D. M. YYYY.',
    LL: 'D. MMMM YYYY.',
    'LL-D': 'MMMM YYYY.',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY. HH:mm',
    'LLL-Y': 'D. MMMM HH:mm',
    LLLL: 'dddd D. MMMM YYYY. HH:mm',
    'LLLL-Y': 'dddd D. MMMM HH:mm',
    l: 'D. M. YYYY.',
    'l-Y': 'D. M.',
    ll: 'D. MMM YYYY.',
    'll-Y': 'D. MMM',
    lll: 'D. MMM YYYY. HH:mm',
    'lll-Y': 'D. MMM HH:mm',
    llll: 'ddd D. MMM YYYY. HH:mm',
    'llll-Y': 'ddd D. MMM HH:mm',
    'll-Y+w': 'ddd, D. MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY. HH:mm ([GMT]Z)',
  },
  past: {
    y: { one: 'prije %s g.', few: 'prije %s g.', other: 'prije %s g.' },
    M: { one: 'prije %s mj.', few: 'prije %s mj.', other: 'prije %s mj.' },
    w: { one: 'prije %s tj.', few: 'prije %s tj.', other: 'prije %s tj.' },
    d: { one: 'prije %s dan', few: 'prije %s dana', other: 'prije %s dana' },
    h: { one: 'prije %s h', few: 'prije %s h', other: 'prije %s h' },
    m: { one: 'prije %s min', few: 'prije %s min', other: 'prije %s min' },
    s: { one: 'prije %s s', few: 'prije %s s', other: 'prije %s s' },
  },
  future: {
    y: { one: 'za %s g.', few: 'za %s g.', other: 'za %s g.' },
    M: { one: 'za %s mj.', few: 'za %s mj.', other: 'za %s mj.' },
    w: { one: 'za %s tj.', few: 'za %s tj.', other: 'za %s tj.' },
    d: { one: 'za %s dan', few: 'za %s dana', other: 'za %s dana' },
    h: { one: 'za %s h', few: 'za %s h', other: 'za %s h' },
    m: { one: 'za %s min', few: 'za %s min', other: 'za %s min' },
    s: { one: 'za %s s', few: 'za %s s', other: 'za %s s' },
  },
  abbr: {
    y: { one: '%s godina', few: '%s godine', other: '%s godina' },
    M: { one: '%s mjesec', few: '%s mjeseca', other: '%s mjeseci' },
    w: { one: '%s tjedan', few: '%s tjedna', other: '%s tjedana' },
    d: { one: '%s dan', few: '%s dana', other: '%s dana' },
    h: { one: '%s sat', few: '%s sata', other: '%s sati' },
    m: { one: '%s minuta', few: '%s minute', other: '%s minuta' },
    s: { one: '%s sekunda', few: '%s sekunde', other: '%s sekundi' },
  },
  justNow: 'upravo',
  yesterday: 'jučer',
  today: 'danas',
  tomorrow: 'sutra',
  weekStart: 1,
};
const localeName: LocaleName = 'hr';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
